import { ImageCircle } from '../imageCircle/imageCircle';

import template from './collapsed.html';
import './collapsed.scss';

export const OrderSummaryCollapsed = angular
    .module('checkout.components.orderSummary.orderSummaryCollapsed', [
        ImageCircle
    ]).component('orderSummaryCollapsed', {
        template,
        bindings: {
            grandTotal: '<',
            totalItems: '<',
            imageOne: '<',
            imageTwo: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/collapsed/collapsed.js